import { ColumnConfig, SortDirectionType, SortFieldDisplayProps } from '@components/design/migrated/Table';
import {
  ColumnHeaderDisplayNameForOR,
  ColumnHeaderForOR,
  SaleType,
  SortKeys,
  SortLabels,
} from '@models/OpportunityReview';
import { isGrowthFairShareString, isGrowthShareOpp } from '@utils/hook/tableCellConst/TableCellConst';
import { sortFields } from '@utils/TableUtils';

export const getOpportunityReviewTableColumns = (selectedSaleType: SaleType, volume?: string): ColumnConfig[] => {
  const singleValueSortField: SortFieldDisplayProps[] = [
    {
      sortKey: SortKeys.Absolute,
      label: SortLabels.Absolute,
      sortDirection: SortDirectionType.asc,
    },
    {
      sortKey: SortKeys.Absolute,
      label: SortLabels.Absolute,
      sortDirection: SortDirectionType.desc,
    },
  ];

  const commonColumnFields = {
    className: 'z-20',
    isSortable: true,
    sortFields,
    compact: true,
  };

  const singleValueColumnFields = {
    className: 'z-20',
    isSortable: true,
    sortFields: singleValueSortField,
    compact: true,
  };

  return [
    {
      headerKey: ColumnHeaderForOR.marketRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.marketRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.marketVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.marketVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.myRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.myRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.myVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.myVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.myRevenueShare,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.myRevenueShare],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.myVolumeShare,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.myVolumeShare],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.overUnderGrowthRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.overUnderGrowthRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.overUnderGrowthVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.overUnderGrowthVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.overUnderFairShareRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.overUnderFairShareRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.overUnderFairShareVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.overUnderFairShareVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.growthOpportunityRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.growthOpportunityRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.growthOpportunityVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.growthOpportunityVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.fairShareOpportunityRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.fairShareOpportunityRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.fairShareOpportunityVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.fairShareOpportunityVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
    {
      headerKey: ColumnHeaderForOR.swotCategoryRevenue,
      name: ColumnHeaderDisplayNameForOR()[ColumnHeaderForOR.swotCategoryRevenue],
      isHidden: selectedSaleType === SaleType.VOLUME,
    },
    {
      headerKey: ColumnHeaderForOR.swotCategoryVolume,
      name: ColumnHeaderDisplayNameForOR(volume)[ColumnHeaderForOR.swotCategoryVolume],
      isHidden: selectedSaleType === SaleType.VALUE,
    },
  ]
    .map((column) => {
      if (
        isGrowthFairShareString(column.headerKey) ||
        isGrowthShareOpp(column.headerKey) ||
        column.headerKey === ColumnHeaderForOR.swotCategoryRevenue ||
        column.headerKey === ColumnHeaderForOR.swotCategoryVolume
      ) {
        return { ...singleValueColumnFields, ...column };
      }
      return { ...commonColumnFields, ...column };
    })
    .filter((column) => !column.isHidden);
};
